const Search = require("./search.png");
const Logo = require("./zevi_logo.webp");
export { Search, Logo };
